import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { oneValueRequiredOwners } from '@app/forms/subscription/services/utile';
import { knowledgeOptions } from '@app/forms/subscription/services/ref';
import { Memoize } from '@app/providers/utils/memoize-decorator';

@Component({
    selector: 'financial-knowledge2',
    templateUrl: './financial-knowledge2.component.html',
    styleUrls: ['./financial-knowledge2.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class FinancialKnowledge2Component implements OnInit {
  options: FormControlOption[] = knowledgeOptions;
  pledge: PledgeRead = null;
  isConsultant: boolean = false;
  constructor(private subscriptionFacade: SubscriptionFacadeService) {}

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.isConsultant = !!this.subscriptionFacade?.getUser()?.sessionConsultant;
  }
  @Memoize(true)
  display(key: 'stock' | 'privateEquity') {
    if (key === 'stock') {
      const knowStock = oneValueRequiredOwners(this.pledge, ['knowStock']);
      if (knowStock) {
        if (this.isConsultant) {
          return true;
        } else return true;
      }
    } else {
      const knowPrivateEquity = oneValueRequiredOwners(this.pledge, [
        'knowPrivateEquity',
      ]);
      if (knowPrivateEquity) {
        if (this.isConsultant) {
          return true;
        } else return true;
      }
    }
  }
}
